module.exports = __webpack_public_path__ + "static/media/kid_avatar_08.3cd24e7b.png";